import { APPAUTH_USERNAME_KEY, APPAUTH_IAM_SETTINGS_KEY } from "./constants";

export const myGeotabAppAuthLogout = async (username: string, callback?: () => void): Promise<void> => {
    if (!(window as any).geotabModules?.auth["logout"]) {
        throw new Error("Native SDK auth logout method is not available");
    }

    (window as any).geotabModules.auth["logout"]({ username }, () => {
        localStorage.removeItem(APPAUTH_USERNAME_KEY);
        localStorage.removeItem(APPAUTH_IAM_SETTINGS_KEY);
        callback && callback();
    });
};

export const driveAppAuthLogout = async (username: string, callback?: () => void): Promise<void> => {
    if (!(window as any).geotabModules?.auth["logout"]) {
        throw new Error("Native SDK auth logout method is not available");
    }

    (window as any).geotabModules.auth["logout"]({ username }, () => {
        callback && callback();
    });
};